import React, { useState, useEffect } from 'react';
import { Form, Select, Button, message, Table, Input, Modal, Alert } from 'antd'; // Añadir Alert al import
import Ciudades from '../../ciudades/ciudades';
import axios from 'axios';
import './SendClientBulkShop.css';

const { Option } = Select;

const SendClientBulkPage = ({ selectedOrders }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [carriers, setCarriers] = useState(['coordinadora', 'interrapidisimo', 'servientrega', 'tcc']);
    const [ordersData, setOrdersData] = useState([]);
    const [cotizaciones, setCotizaciones] = useState({});
    const [selectedCarriers, setSelectedCarriers] = useState({});
    const [loadingCotizar, setLoadingCotizar] = useState(false);
    const codigoSucursal = localStorage.getItem('codigoSucursal');
    const [numeroPreenvio, setNumeroPreenvio] = useState({});
    const [generarGuiaDisabled, setGenerarGuiaDisabled] = useState(false);
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
    const [errorSummary, setErrorSummary] = useState({
        success: [],
        errors: [],
        pdfUrls: {}
    });
    const [modalMessage, setModalMessage] = useState(null); // Añadir estado para mensajes modales
    const [loadingRetry, setLoadingRetry] = useState(false);

    const fetchModalMessage = async () => {
        try {
            const response = await axios.get('https://99envios.app/api/online/modals');
            if (response.data && response.data.activo) {
                setModalMessage(response.data);
            }
        } catch (error) {
            console.error('Error al obtener el mensaje del modal', error);
        }
    };

    useEffect(() => {
        fetchModalMessage();
    }, []);

    const convertToNextKg = (gramsWeight) => {
        const kg = parseFloat(gramsWeight || '0') / 1000;
        return Math.ceil(kg);
    };

    useEffect(() => {
        const fetchBulkOrderData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`https://integration.99envios.app/api/ordersShopify/${codigoSucursal}`);
                const fetchedData = response.data;

                const updatedOrders = selectedOrders.map(order => {
                    // Using ID instead of order_id for lookup
                    const orderData = fetchedData.find(data => data.id === order.id);
                    if (!orderData) {
                        console.warn(`No se encontró la orden con ID: ${order.id}`);
                        return null;
                    }
                    return {
                        ...order,
                        ...orderData,
                        order_id: orderData.id, // Use ID as order_id
                        first_name: orderData?.customer_first_name || '',
                        last_name: orderData?.customer_last_name || '',
                        city: null,
                        address: orderData?.shipping_address || '',
                        phone: orderData?.customer_phone || '',
                        email: orderData?.customer_email || '',
                        total_weight: orderData?.total_weight || '0'
                    };
                }).filter(Boolean); // Remove null entries

                setOrdersData(updatedOrders);
                message.success('Datos recuperados exitosamente');
            } catch (error) {
                console.error('Error:', error);
                message.error('Error al recuperar los datos');
            } finally {
                setLoading(false);
            }
        };

        if (selectedOrders.length > 0) {
            fetchBulkOrderData();
        }
    }, [selectedOrders, codigoSucursal]);

    const handleInputChange = (id, field, value) => {
        const updatedOrders = ordersData.map(order => {
            if (order.id === id) {
                return { ...order, [field]: value };
            }
            return order;
        });
        setOrdersData(updatedOrders);
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            className: 'bulk-shop-col-id',
        },
        {
            title: 'Número de Orden',
            dataIndex: 'order_number',
            key: 'order_number',
            className: 'bulk-shop-col-order',
        },
        {
            title: 'Producto',
            dataIndex: 'product_title',
            key: 'product_title',
        },
        {
            title: 'Precio Total',
            dataIndex: 'total_price',
            key: 'total_price',
            render: (price) => `$${parseFloat(price).toLocaleString()}`,
        },
        {
            title: 'Estado Financiero',
            dataIndex: 'financial_status',
            key: 'financial_status',
        },
        {
            title: 'Estado de Envío',
            dataIndex: 'fulfillment_status',
            key: 'fulfillment_status',
        },
        {
            title: 'Cliente',
            key: 'cliente',
            render: (_, record) => (
                <div className="client-inputs">
                    <Input
                        className="first-name-input"
                        value={record.first_name}
                        onChange={(e) => handleNameChange(record.id, 'first_name', e.target.value)}
                        placeholder="Nombre"
                        required
                    />
                    <Input
                        className="last-name-input"
                        value={record.last_name}
                        onChange={(e) => handleNameChange(record.id, 'last_name', e.target.value)}
                        placeholder="Apellido"
                        required
                    />
                </div>
            ),
        },
        {
            title: 'Email',
            dataIndex: 'customer_email',
            key: 'customer_email',
        },
        {
            title: 'Teléfono',
            dataIndex: 'customer_phone',
            key: 'customer_phone',
        },
        {
            title: 'Ciudad de Envío',
            dataIndex: 'shipping_city',
            key: 'shipping_city',
        },
        {
            title: 'Ciudad',
            key: 'ciudad',
            render: (_, record) => (
                <Select
                    showSearch
                    className="bulk-shop-select-city"
                    value={record.city}
                    onChange={(value) => handleCityChange(record.id, value)}
                    placeholder="Buscar ciudad"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {Ciudades.map((ciudad) => (
                        <Option key={ciudad.value} value={ciudad.value}>
                            {ciudad.label}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: 'Cotizaciones',
            key: 'cotizaciones',
            render: (_, record) => (
                <div className="cotizaciones-container">
                    {carriers.map(carrier => {
                        const quote = cotizaciones[record.order_id]?.[carrier];
                        return (
                            <div key={carrier} className="cotizacion-item">
                                <strong style={{ textTransform: 'capitalize' }}>{carrier}:</strong>
                                <span style={{ 
                                    color: quote?.exito ? '#52c41a' : '#d4380d',
                                    fontWeight: '500'
                                }}>
                                    {quote?.exito ? 
                                        `$${quote.valor?.toLocaleString() || 0}` : 
                                        'N/A'
                                    }
                                </span>
                            </div>
                        );
                    })}
                </div>
            ),
        },
        {
            title: 'Transportadora',
            key: 'transportadora',
            render: (_, record) => (
                <Select
                    className="bulk-shop-select-carrier"
                    value={selectedCarriers[record.order_id]}
                    onChange={(value) => handleCarrierChange(record.order_id, value)}
                >
                    {carriers.map(carrier => (
                        <Option key={carrier} value={carrier}>
                            {carrier}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: 'Cantidad',
            key: 'cantidad',
            render: (_, record) => (
                <Input
                    value={record.product_quantity}
                    onChange={(e) => handleInputChange(record.id, 'product_quantity', e.target.value)}
                    placeholder="Cantidad"
                    required
                />
            ),
        },
        {
            title: 'Observaciones',
            key: 'observaciones',
            render: (_, record) => (
                <Input
                    value={record.notes}
                    onChange={(e) => handleInputChange(record.id, 'notes', e.target.value)}
                    placeholder="Observaciones"
                    required
                />
            ),
        },
        {
            title: 'Peso Producto',
            key: 'pesoProducto',
            render: (_, record) => {
                const weightInKg = convertToNextKg(record.total_weight);
                
                return (
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <Input
                            type="number"
                            step="1"
                            value={weightInKg}
                            onChange={(e) => {
                                const newWeightInGrams = Math.ceil(parseFloat(e.target.value || '0')) * 1000;
                                handleInputChange(record.id, 'total_weight', String(newWeightInGrams));
                            }}
                            placeholder="Peso (kg)"
                            style={{ width: '100px' }}
                            suffix="kg"
                        />
                    </div>
                );
            },
        },
    ].filter(col => col.key !== 'error' && col.key !== 'peso_cantidad'); // Remove error and peso_cantidad columns

    const handleNameChange = (id, field, value) => {
        const updatedOrders = ordersData.map(order => {
            if (order.id === id) {
                return { ...order, [field]: value };
            }
            return order;
        });
        setOrdersData(updatedOrders);
    };

    const handleCityChange = (id, value) => {
        const updatedOrders = ordersData.map(order => {
            if (order.id === id) {
                return { ...order, city: value };
            }
            return order;
        });
        setOrdersData(updatedOrders);
    };

    const handleQuotation = async (order) => {
        setLoadingCotizar(true);
        try {
            if (!order.city || !Number(order.product_price) || !Number(order.product_quantity)) {
                message.error(`Complete todos los campos para la orden ${order.order_number}`);
                return;
            }

            const salePrice = Number(order.product_price);
            const quantity = Number(order.product_quantity);
            const subtotal = salePrice * quantity;
            const pesoTotal = parseFloat(order.product_weight) * quantity;

            const allQuotes = {};
            for (const carrier of carriers) {
                try {
                    const current = new Date();
                    const formattedDate = ("0" + current.getDate()).slice(-2) + "-" +
                          ("0" + (current.getMonth() + 1)).slice(-2) + "-" +
                           current.getFullYear();
                    const cotizacionData = {
                        destino: {
                            nombre: "",
                            codigo: order.city,
                        },
                        origen: {
                            nombre: "",
                            codigo: "",
                        },
                        IdTipoEntrega: 1,
                        IdServicio: 1,
                        peso: pesoTotal,
                        largo: 1,
                        ancho: 1,
                        alto: 1,
                        fecha: formattedDate,
                        AplicaContrapago: true,
                        valorDeclarado: String(subtotal),
                        carrier: carrier
                    };

                    const response = await axios.post(
                        `https://integration.99envios.app/api/sucursal/cotizar/${codigoSucursal}`,
                        cotizacionData
                    );

                    // Safely extract carrier data
                    const carrierData = response.data[carrier] || response.data;
                    
                    allQuotes[carrier] = {
                        exito: carrierData.exito || false,
                        valor: carrierData.valor || 0,
                        mensaje: carrierData.mensaje || '',
                        dias: carrierData.dias || '0',
                        // Add optional fields with default values
                        valor_contrapago: carrierData.valor_contrapago || 0,
                        sobreflete: carrierData.sobreflete || 0
                    };

                } catch (error) {
                    console.error(`Error quoting ${carrier}:`, error);
                    allQuotes[carrier] = {
                        exito: false,
                        valor: 0,
                        mensaje: 'Error en la cotización',
                        dias: '0',
                        valor_contrapago: 0,
                        sobreflete: 0
                    };
                }
            }

            setCotizaciones(prev => ({
                ...prev,
                [order.order_id]: allQuotes
            }));

            message.success(`Cotizaciones completadas para la orden ${order.order_number}`);

        } catch (error) {
            message.error(`Error al cotizar la orden ${order.order_number}`);
            console.error('Error al cotizar:', error);
        } finally {
            setLoadingCotizar(false);
        }
    };

    const handleCarrierChange = (orderId, value) => {
        setSelectedCarriers(prev => ({
            ...prev,
            [orderId]: value,
        }));
    };

    const handleBulkSubmit = async () => {
        setLoadingSubmit(true);
        const successOrders = [];
        const failedOrders = [];
        const pdfUrls = {};
        const errorMessages = {}; // Add this to store error messages

        try {
            // Validar órdenes
            const incompleteOrders = [];
            for (const order of ordersData) {
                if (
                    !order.first_name ||
                    !order.last_name ||
                    !order.city ||
                    !cotizaciones[order.order_id] ||
                    !selectedCarriers[order.order_id]
                ) {
                    incompleteOrders.push(order.order_number);
                }
            }

            if (incompleteOrders.length > 0) {
                message.warning(
                    `No se puede generar el envío de manera masiva para las órdenes: ${incompleteOrders.join(
                        ', '
                    )}. Por favor, hágalas individualmente ya que faltan datos.`
                );
                setLoadingSubmit(false);
                return;
            }

            // Crear todas las solicitudes
            const requests = ordersData.map(order => {
                return new Promise(async (resolve) => {
                    try {
                        // ...preparación de datos de la orden...
                        const carrier = selectedCarriers[order.order_id];
                        const orderData = {
                            // Si existe product_id_variant, se envía como IdProducto (y se usa product_id para IdVariacion), de lo contrario se usa product_id
                            IdProducto: order.product_id_variant ? String(order.product_id_variant) : String(order.product_id),
                            IdVariacion: order.product_id_variant ? String(order.product_id) : '',
                            Cantidad: 1, // Siempre será 1
                            AplicaContrapago: true,
                            // Se cambia 'order.weight' por 'order.product_weight'
                            pesoProducto: convertToNextKg(order.total_weight),
                            nombreProducto: order.product_title,
                            valorDeclarado: String(order.total_price), // Add valorDeclarado field
                            Destinatario: {
                                nombre: order.first_name,
                                primerApellido: order.last_name ? order.last_name.split(' ')[0] : '',
                                segundoApellido: order.last_name && order.last_name.split(' ').length > 1 ? order.last_name.split(' ')[1] : '',
                                telefono: order.phone,
                                direccion: order.address,
                                idLocalidad: order.city,
                                correo: order.email,
                            },
                            Observaciones: order.notes || '',
                            transportadora: {
                                pais: 'colombia',
                                nombre: carrier || '',
                            },
                            // Verificar que esto es correcto
                            origenCreacion: 6,
                            idShopy: order.id,

                        };
                        const id = localStorage.getItem('usuario_id');
                        const token = localStorage.getItem('token');
                        const config = {
                            headers: {
                                Authorization: token ? `Bearer ${token}` : '',
                                'Content-Type': 'application/json',
                            },
                        };

                        const response = await axios.post(`https://99envios.app/api/orden_save/${id}`, orderData, config);

                        // Actualizar la condición de éxito para verificar 'numero_orden'
                        if (response.status === 200 && response.data.numero_orden) {
                            successOrders.push(order.order_number);
                            // Almacena la URL del PDF asociada al número de orden
                            if (response.data.pdf) {
                                pdfUrls[order.order_number] = response.data.pdf;
                            }
                        } else {
                            console.error(`Error en la respuesta de la orden ${order.order_number}:`, response);
                            failedOrders.push(order.order_number);
                            // Store error message if present
                            if (response.data.error) {
                                errorMessages[order.order_number] = response.data.error;
                            }
                        }
                    } catch (error) {
                        console.error(`Error al enviar la orden ${order.order_number}:`, error);
                        failedOrders.push(order.order_number);
                        // Store error message from API response
                        if (error.response?.data?.errors?.error) {
                            // Si es un array, toma el primer mensaje
                            if (Array.isArray(error.response.data.errors.error)) {
                                errorMessages[order.order_number] = error.response.data.errors.error[0];
                            } else {
                                // Si es un string directo
                                errorMessages[order.order_number] = error.response.data.errors.error;
                            }
                        } else if (error.response?.data?.error) {
                            // Formato anterior de error
                            errorMessages[order.order_number] = error.response.data.error;
                        } else {
                            errorMessages[order.order_number] = 'Error al procesar la orden';
                        }
                    } finally {
                        resolve();
                    }
                });
            });

            await Promise.all(requests);

            setErrorSummary({
                success: successOrders,
                errors: failedOrders,
                pdfUrls: pdfUrls,
                errorMessages: errorMessages // Add error messages to the summary
            });

            setIsErrorModalVisible(true);

        } catch (error) {
            message.error('Error al enviar los pedidos');
            console.error('Error al enviar los pedidos:', error);
        } finally {
            setLoadingSubmit(false);
        }
    };

    const handleBulkQuotation = async () => {
        setLoadingCotizar(true);
        try {
            const incompleteOrders = ordersData.filter(order => !order.city || !order.total_price);

            if (incompleteOrders.length > 0) {
                const orderNumbers = incompleteOrders.map(o => o.order_number).join(', ');
                message.error(`Complete todos los campos para las órdenes: ${orderNumbers}`);
                return;
            }

            const newQuotes = {};
            for (const order of ordersData) {
                if (cotizaciones[order.order_id] && Object.keys(cotizaciones[order.order_id]).length > 0) {
                    newQuotes[order.order_id] = cotizaciones[order.order_id];
                    continue;
                }

                const weightInKg = convertToNextKg(order.total_weight);

                const current = new Date();
                const formattedDate = ("0" + current.getDate()).slice(-2) + "-" +
                                      ("0" + (current.getMonth() + 1)).slice(-2) + "-" +
                                       current.getFullYear();

                const cotizacionData = {
                    destino: {
                        nombre: "",
                        codigo: order.city,
                    },
                    origen: {
                        nombre: "",
                        codigo: "",
                    },
                    IdTipoEntrega: 1,
                    IdServicio: 1,
                    peso: weightInKg,
                    largo: 1,
                    ancho: 1,
                    alto: 1,
                    fecha: formattedDate,
                    AplicaContrapago: true,
                    valorDeclarado: String(order.total_price)
                };

                try {
                    const response = await axios.post(
                        `https://integration.99envios.app/api/sucursal/cotizar/${codigoSucursal}`,
                        cotizacionData
                    );

                    const carrierQuotes = {};
                    for (const carrier of carriers) {
                        const carrierData = response.data[carrier] || response.data;
                        carrierQuotes[carrier] = {
                            exito: carrierData.exito || false,
                            valor: carrierData.valor || 0,
                            mensaje: carrierData.mensaje || '',
                            dias: carrierData.dias || '0',
                            valor_contrapago: carrierData.valor_contrapago || 0,
                            sobreflete: carrierData.sobreflete || 0
                        };
                    }
                    newQuotes[order.order_id] = carrierQuotes;

                } catch (error) {
                    console.error(`Error al cotizar la orden ${order.order_number}:`, error);
                    message.error(`Error al cotizar la orden ${order.order_number}`);
                    // Crear cotizaciones vacías en caso de error
                    newQuotes[order.order_id] = carriers.reduce((acc, carrier) => ({
                        ...acc,
                        [carrier]: {
                            exito: false,
                            valor: 0,
                            mensaje: 'Error en la cotización',
                            dias: '0',
                            valor_contrapago: 0,
                            sobreflete: 0
                        }
                    }), {});
                }
            }

            setCotizaciones(prev => ({
                ...prev,
                ...newQuotes
            }));
            message.success('Cotizaciones completadas');

        } catch (error) {
            message.error('Error al realizar las cotizaciones');
            console.error('Error al cotizar:', error);
        } finally {
            setLoadingCotizar(false);
        }
    };

    const handleRetry = async () => {
        setLoadingRetry(true);
        try {
            const failedOrdersData = ordersData.filter(order => 
                errorSummary.errors.includes(order.order_number)
            );

            if (failedOrdersData.length === 0) {
                message.info('No hay órdenes para reintentar');
                setLoadingRetry(false);
                return;
            }

            const retryResults = {
                success: [],
                errors: [],
                pdfUrls: {},
                errorMessages: {}
            };

            const requests = failedOrdersData.map(order => {
                return new Promise(async (resolve) => {
                    try {
                        const carrier = selectedCarriers[order.order_id];
                        const orderData = {
                            // Si existe product_id_variant, se envía como IdProducto (y se usa product_id para IdVariacion), de lo contrario se usa product_id
                            IdProducto: order.product_id_variant ? String(order.product_id_variant) : String(order.product_id),
                            IdVariacion: order.product_id_variant ? String(order.product_id) : '',
                            Cantidad: 1, // Siempre será 1
                            AplicaContrapago: true,
                            // Se cambia 'order.weight' por 'order.product_weight'
                            pesoProducto: convertToNextKg(order.total_weight),
                            nombreProducto: order.product_title,
                            valorDeclarado: String(order.total_price), // Add valorDeclarado field
                            Destinatario: {
                                nombre: order.first_name,
                                primerApellido: order.last_name ? order.last_name.split(' ')[0] : '',
                                segundoApellido: order.last_name && order.last_name.split(' ').length > 1 ? order.last_name.split(' ')[1] : '',
                                telefono: order.phone,
                                direccion: order.address,
                                idLocalidad: order.city,
                                correo: order.email,
                            },
                            Observaciones: order.notes || '',
                            transportadora: {
                                pais: 'colombia',
                                nombre: carrier || '',
                            },
                            // Verificar que esto es correcto
                            origenCreacion: 6,
                            idShopy: order.id,

                        };
                        const id = localStorage.getItem('usuario_id');
                        const token = localStorage.getItem('token');
                        const config = {
                            headers: {
                                Authorization: token ? `Bearer ${token}` : '',
                                'Content-Type': 'application/json',
                            },
                        };

                        const response = await axios.post(`https://99envios.app/api/orden_save/${id}`, orderData, config);

                        if (response.status === 200 && response.data.numero_orden) {
                            retryResults.success.push(order.order_number);
                            if (response.data.pdf) {
                                retryResults.pdfUrls[order.order_number] = response.data.pdf;
                            }
                        } else {
                            retryResults.errors.push(order.order_number);
                            if (response.data.error) {
                                retryResults.errorMessages[order.order_number] = response.data.error;
                            }
                        }
                    } catch (error) {
                        retryResults.errors.push(order.order_number);
                        if (error.response?.data?.errors?.error) {
                            retryResults.errorMessages[order.order_number] = Array.isArray(error.response.data.errors.error) 
                                ? error.response.data.errors.error[0] 
                                : error.response.data.errors.error;
                        } else if (error.response?.data?.error) {
                            retryResults.errorMessages[order.order_number] = error.response.data.error;
                        } else {
                            retryResults.errorMessages[order.order_number] = 'Error al procesar la orden';
                        }
                    } finally {
                        resolve();
                    }
                });
            });

            await Promise.all(requests);

            setErrorSummary(prev => ({
                success: [...prev.success.filter(orderNum => 
                    !prev.errors.includes(orderNum)), // Mantener solo las exitosas originales
                    ...retryResults.success], // Añadir las nuevas exitosas
                errors: retryResults.errors,
                pdfUrls: {
                    ...prev.pdfUrls,
                    ...retryResults.pdfUrls
                },
                errorMessages: retryResults.errorMessages,
                isRetry: true // Indicador para el modal
            }));

        } catch (error) {
            message.error('Error al reintentar los envíos');
            console.error('Error al reintentar:', error);
        } finally {
            setLoadingRetry(false);
        }
    };

    const ErrorModal = () => {
        // Determinar qué órdenes mostrar basado en si es un reintento
        const ordersToShow = errorSummary.isRetry 
            ? errorSummary.success.filter(orderNum => 
                errorSummary.errors.includes(orderNum))
            : errorSummary.success;

        return (
            <Modal
                title={errorSummary.isRetry ? "Resultado del Reintento" : "Resumen de Envíos"}
                visible={isErrorModalVisible}
                onOk={() => setIsErrorModalVisible(false)}
                onCancel={() => setIsErrorModalVisible(false)}
                footer={[
                    <Button 
                        key="retry" 
                        type="primary"
                        danger
                        onClick={handleRetry}
                        loading={loadingRetry}
                        disabled={!errorSummary.errors.length}
                    >
                        Volver a intentar ({errorSummary.errors.length})
                    </Button>,
                    <Button key="close" type="primary" onClick={() => setIsErrorModalVisible(false)}>
                        Cerrar
                    </Button>
                ]}
            >
                <div>
                    {errorSummary.isRetry ? (
                        <>
                            <h3>Resultado del reintento:</h3>
                            <p>Órdenes procesadas exitosamente: {ordersToShow.length}</p>
                        </>
                    ) : (
                        <h3>Envíos exitosos: {errorSummary.success.length}</h3>
                    )}
                    
                    {ordersToShow.length > 0 && (
                        <>
                            <p>Puedes descargar las guías generadas a continuación:</p>
                            <ul>
                                {ordersToShow.map((orderNumber) => (
                                    <li key={orderNumber}>
                                        Orden #{orderNumber}{' '}
                                        {errorSummary.pdfUrls[orderNumber] && (
                                            <Button
                                                type="link"
                                                onClick={() => window.open(errorSummary.pdfUrls[orderNumber], '_blank')}
                                            >
                                                Descargar Guía
                                            </Button>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                    
                    <h3>Envíos con error: {errorSummary.errors.length}</h3>
                    {errorSummary.errors.length > 0 && (
                        <>
                            <p style={{ color: 'red' }}>
                                Las siguientes órdenes tuvieron errores:
                            </p>
                            <ul>
                                {errorSummary.errors.map((orderNumber) => (
                                    <li key={orderNumber}>
                                        Orden #{orderNumber}
                                        {errorSummary.errorMessages?.[orderNumber] && (
                                            <div style={{ marginLeft: '20px', fontSize: '0.9em', color: '#d93025' }}>
                                                Error: {errorSummary.errorMessages[orderNumber]}
                                            </div>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            </Modal>
        );
    };

    return (
        <div className="bulk-shop-page">
            {modalMessage && modalMessage.activo && (
                <Alert 
                    message={modalMessage.mensaje} 
                    type="info" 
                    closable 
                    style={{ marginBottom: '16px' }}
                />
            )}
            <div className="instructions">
                <h2>Pasos a seguir</h2>
                <ol>
                    <li>Verificar/actualizar datos de órdenes</li>
                    <li>Seleccionar ciudad de destino</li>
                    <li>Seleccionar transportadora</li>
                    <li>Cotizar envíos</li>
                    <li>Revisar cotizaciones</li>
                    <li>Generar y descargar guías</li>
                </ol>
            </div>
            <div className="bulk-shop-table-wrapper">
                <Table
                    className="bulk-shop-table"
                    dataSource={ordersData}
                    columns={columns}
                    rowKey="order_id"
                    pagination={false} // Remove pagination for better scrolling
                    scroll={{
                        x: 'max-content',
                        y: 'calc(100vh - 400px)'  // Adjust based on viewport height
                    }}
                    sticky
                />
            </div>
            <div className="bulk-shop-buttons">
                <Button
                    className="bulk-shop-btn-quote"
                    type="primary"
                    onClick={handleBulkQuotation}
                    loading={loadingCotizar}
                    disabled={ordersData.some(order => !order.city)}
                >
                    Cotizar Todas
                </Button>
                <Button
                    className="bulk-shop-btn-generate"
                    type="primary"
                    onClick={handleBulkSubmit}
                    loading={loadingSubmit}
                    disabled={ordersData.some(order => !order.first_name || !order.last_name || !order.city || !cotizaciones[order.order_id] || !selectedCarriers[order.order_id])}
                >
                    Generar Guías
                </Button>
            </div>
            <ErrorModal />
        </div>
    );
};

export default SendClientBulkPage;